import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'code',
      component: () => import('@/views/Code.vue')
    },
    {
      path: '/debug',
      name: 'debug',
      component: () => import('@/views/Debug.vue')
    },
    {
      path: '/swiper',
      name: 'swiper',
      component: () => import('@/views/Swiper.vue')
    },
    {
      path: '/zhuan',
      name: 'zhuan',
      component: () => import('@/views/products/Zhuan.vue')
    },
    {
      path: '/xian',
      name: 'xian',
      component: () => import('@/views/products/Xian.vue')
    },
    {
      path: '/yue',
      name: 'yue',
      component: () => import('@/views/products/Yue.vue')
    },
    {
      path: '/tea',
      name: 'tea',
      component: () => import('@/views/products/Tea.vue')
    },
    {
      path: '/hong',
      name: 'hong',
      component: () => import('@/views/products/Hong.vue')
    },
    {
      path: '/lottery',
      name: 'lottery',
      component: () => import('@/views/Lottery.vue')
    },
    {
      path: '/record',
      name: 'record',
      component: () => import('@/views/Record.vue')
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js